import React from "react";
import { useNavigate } from "react-router-dom";
import EventCard from "./EventCard";

const EventList = ({ events, eventtype }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-full">
      <div id="events-container" className="w-full pt-8 pb-4">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
          {events.map((event) => (
            <div key={event.id} className="flex justify-center mb-5">
              <EventCard
                event={event}
                eventtype={eventtype}
                width={"sm:w-[460px]"}
                onButtonClick={() =>
                  navigate(
                    `/${eventtype}/${event?.searchKey}`
                  )
                }
                className="w-full max-w-sm"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventList;
